import React from "react";
import {
  Container,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import { Build } from "@mui/icons-material";

const RMReportsPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box 
        sx={{ 
          py: 8, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          minHeight: '60vh'
        }}
      >
        <Paper
          sx={{
            p: 6,
            textAlign: "center",
            bgcolor: "grey.50",
            border: "2px dashed",
            borderColor: "grey.300",
            borderRadius: 2,
            maxWidth: 400,
            width: '100%'
          }}
        >
          <Build sx={{ fontSize: 60, color: "grey.500", mb: 2 }} />
          <Typography variant="h4" sx={{ mb: 2, fontWeight: "bold" }}>
            R & M Reports
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This page is under construction. R & M Reports functionality will be available soon.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default RMReportsPage;
